import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";

import { getMonthAndYear, formatName } from "../../utils/generalUtils";

import UPLOGO from "../../generatePdf/components/up-logo.jpg";
import Ibm from "../../generatePdf/components/ibm.ttf";

import ArialRegular from "../../generatePdf/components/Arial/ARIAL.TTF";
import ArialBold from "../../generatePdf/components/Arial/ARIALBD.TTF";
import ArialItalic from "../../generatePdf/components/Arial/ARIALI.TTF";
import ArialNarrowItalic from "../../generatePdf/components/Arial/ARIALNI.TTF";
import ArialNarrowBold from "../../generatePdf/components/Arial/ARIALNB.TTF";
import ArialNarrowBoldItalic from "../../generatePdf/components/Arial/ARIALNBI.TTF";

Font.register({
  family: "ibm",
  format: "truetype",
  src: Ibm,
});

Font.register({
  family: "Arial",
  format: "truetype",
  src: ArialRegular,
});

Font.register({
  family: "ArialBold",
  format: "truetype",
  src: ArialBold,
});

Font.register({
  family: "ArialItalic",
  format: "truetype",
  src: ArialItalic,
});

Font.register({
  family: "ArialNarrowItalic",
  format: "truetype",
  src: ArialNarrowItalic,
});

Font.register({
  family: "ArialNarrowBold",
  format: "truetype",
  src: ArialNarrowBold,
});

Font.register({
  family: "ArialNarrowBoldItalic",
  format: "truetype",
  src: ArialNarrowBoldItalic,
});

const styles = StyleSheet.create({
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: "15px",
    fontFamily: "Arial",
    gap: "5px",
  },
  headerupname: {
    fontSize: "12px",
    display: "flex",
    flexDirection: "column",
    fontFamily: "ArialBold",
  },
  subHeader: {
    paddingTop: "20px",
    fontFamily: "ibm",
    fontSize: "8px",
    alignItems: "left",
  },
  docuTypeName: {
    alignItems: "center",
    paddingTop: "15px",
    fontFamily: "ArialBold",
    fontSize: "12px",
  },
  formContainer: {
    paddingTop: "30px",
    fontSize: "10px",
    gap: "6px",
  },
  formContainerCos: {
    paddingTop: "10px",
    fontSize: "10px",
    gap: "6px",
    fontFamily: "Arial",
  },
  fieldContainer: {
    fontSize: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    letterSpacing: ".1px",
  },
  fieldName: {
    fontSize: "10px",
    letterSpacing: ".1px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontFamily: "Arial",
    width: "50%",
  },
  activity: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontFamily: "Arial",
    width: "60%",
    textAlign: "center",
    padding: "0px 10px",
    fontSize: "10px",
    marginVertical: 3,
    marginHorizontal: 5,
    borderBottom: 1,
    borderColor: "black",
  },
  hours: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontFamily: "Arial",
    width: "40%",
    textAlign: "center",
    padding: "0px 10px",
    fontSize: "10px",
    marginVertical: 3,
    marginHorizontal: 5,
    borderBottom: 1,
    borderColor: "black",
  },
  fieldItem: {
    letterSpacing: ".1px",
    paddingLeft: "10px",
    width: "50%",
    textTransform: "uppercase",
  },
  approvalContainer: {
    fontSize: "12px",
    gap: "12px",
  },
  approvalFields: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  approvalFieldName: {
    fontSize: "8px",
    fontFamily: "ArialItalic",
    border: "1px solid black",
    textAlign: "center",
  },
  endnoteContainer: {
    paddingTop: "20px",
  },
  image: {
    width: 50,
  },
});

function CosFormat({ contents, isEmployee }) {
  const requesterName = contents.formattedName
    ? contents.formattedName
    : contents.name;
  const positionName = contents?.submitter_position;
  const positionUnit = contents?.submitter_position_unit;
  const approverName = isEmployee
    ? formatName(
        contents?.submission?.approval?.[0]?.approver?.first_name,
        contents?.submission?.approval?.[0]?.approver?.middle_name,
        contents?.submission?.approval?.[0]?.approver?.last_name,
        "lfmcut"
      )
    : contents?.formattedApproverName;

  const documentSubmitted = contents?.date_submitted;

  const act1 = contents?.act1;
  const act2 = contents?.act2;
  const act3 = contents?.act3;
  const act4 = contents?.act4;
  const act5 = contents?.act5;

  const week1hour = contents?.week1_hours;
  const week2hour = contents?.week2_hours;
  const week3hour = contents?.week3_hours;
  const week4hour = contents?.week4_hours;
  const week5hour = contents?.week5_hours;

  const absent = contents?.absent;

  const approvalDate = contents?.approval_date;

  const startDate = contents?.start_date;
  const endDate = contents?.end_date;

  return (
    <View>
      <View>
        <View style={styles.header}>
          <Image src={UPLOGO} style={styles.image} />
          <View style={styles.headerupname}>
            <Text>University Of The Philippines</Text>
            <Text>OPEN UNIVERSITY</Text>
            <Text
              style={{
                fontSize: "10px",
                fontWeight: "200",
                fontFamily: "Arial",
              }}
            >
              Los Banos Laguna
            </Text>
          </View>
        </View>
        <View style={styles.subHeader}>
          <Text>UP-HR Form No. 0055 (UP Form No. 65-A)</Text>
          <Text>Revised 12 Oct 2016</Text>
        </View>
        <View style={styles.docuTypeName}>
          <Text>CERTIFICATE OF SERVICE</Text>
        </View>

        <View style={styles.formContainerCos}>
          <Text>
            For the month of{" "}
            <Text style={{ textDecoration: "underline" }}>
              {getMonthAndYear(startDate)}
            </Text>
            {",  "}
          </Text>

          <View>
            <View style={styles.fieldContainer}>
              <Text>Name: </Text>{" "}
              <Text
                style={{
                  textTransform: "uppercase",
                  textDecoration: "underline",
                }}
              >
                {requesterName}
              </Text>
            </View>

            <View style={styles.fieldContainer}>
              <Text>Position: </Text>{" "}
              <Text
                style={{
                  textTransform: "uppercase",
                  textDecoration: "underline",
                }}
              >
                {positionName || ""}
              </Text>
            </View>

            <View style={styles.fieldContainer}>
              <Text>Unit: </Text>{" "}
              <Text
                style={{
                  textDecoration: "underline",
                }}
              >
                {positionUnit || ""}
              </Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View
              style={{
                ...styles.activity,
                textAlign: "center",
                borderBottom: 0,
                marginHorizontal: 0,
              }}
            >
              <Text>Activities other than Teaching such as Research etc.</Text>
            </View>
            <View
              style={{
                ...styles.hours,
                borderBottom: 0,
                marginHorizontal: 0,
                textAlign: "center",
              }}
            >
              <Text>Approximate no. of hours per week</Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View style={styles.activity}>
              <Text>{act1 ? act1 : "N/A"}</Text>
            </View>
            <View style={styles.hours}>
              <Text>{week1hour ? week1hour : "N/A"}</Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View style={styles.activity}>
              <Text>{act2 ? act2 : "N/A"}</Text>
            </View>
            <View style={styles.hours}>
              <Text>{week2hour ? week2hour : "N/A"}</Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View style={styles.activity}>
              <Text>{act3 ? act3 : "N/A"}</Text>
            </View>
            <View style={styles.hours}>
              <Text>{week3hour ? week3hour : "N/A"}</Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View style={styles.activity}>
              <Text>{act4 ? act4 : "N/A"}</Text>
            </View>
            <View style={styles.hours}>
              <Text>{week4hour ? week4hour : "N/A"}</Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View style={styles.activity}>
              <Text>{act5 ? act5 : "N/A"}</Text>
            </View>
            <View style={styles.hours}>
              <Text>{week5hour ? week5hour : "N/A"}</Text>
            </View>
          </View>

          <View
            style={{
              paddingLeft: "10px",
              justifyContent: "flex-start",
              letterSpacing: ".1px",
            }}
          >
            <Text>
              I hereby certify, upon my honor, that I have rendered full service
              for the period of{" "}
              <Text style={{ textDecoration: "underline" }}>
                {startDate} to {endDate}
              </Text>
              .
            </Text>
            {absent ? <Text>Except: {absent}</Text> : null}
          </View>

          <View
            style={{
              ...styles.fieldContainer,
              fontSize: "8px",
              justifyContent: "flex-end",
              paddingTop: "15px",
            }}
          >
            <Text>Date & Time Submitted: {documentSubmitted}</Text>
          </View>
        </View>

        <View
          style={{
            ...styles.approvalContainer,
            paddingTop: "30px",
            fontSize: "10px",
          }}
        >
          <Text>Approval History</Text>
          <View style={styles.approvalFields}>
            <Text
              style={{
                ...styles.approvalFieldName,
                width: "40%",
              }}
            >
              Name
            </Text>
            <Text
              style={{
                ...styles.approvalFieldName,
                width: "30%",
                borderLeft: "none",
                borderRight: "none",
              }}
            >
              Action
            </Text>
            <Text
              style={{
                ...styles.approvalFieldName,
                width: "30%",
              }}
            >
              Date/Time
            </Text>
          </View>
        </View>

        <View style={styles.approvalContainer}>
          <View style={styles.approvalFields}>
            <Text
              style={{
                ...styles.approvalFieldName,
                borderTop: "none",
                textTransform: "uppercase",
                width: "40%",
              }}
            >
              {approverName}
            </Text>
            <Text
              style={{
                ...styles.approvalFieldName,
                borderTop: "none",
                borderLeft: "none",
                borderRight: "none",
                textTransform: "uppercase",
                width: "30%",
              }}
            >
              approved
            </Text>
            <Text
              style={{
                ...styles.approvalFieldName,
                borderTop: "none",
                textTransform: "uppercase",
                width: "30%",
              }}
            >
              {approvalDate}
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.endnoteContainer}>
        <View style={{ fontFamily: "ArialItalic", fontSize: "8px" }}>
          <Text>This is a UPOU-PIVOT generated report.</Text>
          <Text>Approver's signature not required</Text>
        </View>
        <View style={{ fontSize: "10px", paddingTop: "15px", fontSize: "8px" }}>
          <Text>Reference:</Text>
          <Text style={{ paddingLeft: "30px", fontSize: "8px" }}>
            Administrative Order No. PAEP 16-28, 25 May 2016 "Use of Official UP
            Mail and Online Release of Service Records, Travel Order, Employment
            Certification and other Certificates."{" "}
          </Text>
        </View>
      </View>
    </View>
  );
}

export default CosFormat;
